import { render, staticRenderFns } from "./JournalEntrySubmissions.vue?vue&type=template&id=65009942&scoped=true&"
import script from "./JournalEntrySubmissions.vue?vue&type=script&lang=js&"
export * from "./JournalEntrySubmissions.vue?vue&type=script&lang=js&"
import style0 from "./JournalEntrySubmissions.vue?vue&type=style&index=0&id=65009942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65009942",
  null
  
)

export default component.exports